import React, { useState, useEffect, useCallback } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from 'reactstrap';
import api from '../../services/api';

const EditScheduleDateModal = ({ isOpen, toggle, onSave, scheduleDate, leagueId, scheduleId }) => {
  const [weeks, setWeeks] = useState([]);
  const [editedDate, setEditedDate] = useState({
    league_week: '',
    date: '',
    max_date: ''
  });

  const fetchWeeks = useCallback(async () => {
    if (!leagueId) return;
    try {
      const response = await api.get(`/league-weeks/?league=${leagueId}`);
      setWeeks(response.data);
    } catch (error) {
      console.error('Error fetching weeks:', error);
    }
  }, [leagueId]);

  useEffect(() => {
    if (isOpen && leagueId) {
      fetchWeeks();
    }
  }, [isOpen, leagueId, fetchWeeks]);

  useEffect(() => {
    if (scheduleDate) {
      setEditedDate({
        league_week: scheduleDate.league_week || '',
        date: scheduleDate.date || '',
        max_date: scheduleDate.max_date || ''
      });
    }
  }, [scheduleDate]);

  const handleSave = () => {
    onSave({
      ...editedDate,
      schedule: scheduleId
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedDate(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Schedule Date</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="league_week">Week</Label>
          <Input
            type="select"
            id="league_week"
            name="league_week"
            value={editedDate.league_week}
            onChange={handleChange}
          >
            <option value="">-- Select Week (Optional) --</option>
            {weeks.map(w => (
              <option key={w.id} value={w.id}>
                Week {w.week} {w.notes && `(${w.notes})`}
              </option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="date">Date *</Label>
          <Input
            type="date"
            id="date"
            name="date"
            value={editedDate.date}
            onChange={handleChange}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="max_date">Max Date (for ranges)</Label>
          <Input
            type="date"
            id="max_date"
            name="max_date"
            value={editedDate.max_date}
            onChange={handleChange}
          />
          <small className="text-muted">Optional: Set an end date for date ranges</small>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={!editedDate.date}>
          Save Changes
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditScheduleDateModal;
